"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _reactRedux = require("react-redux");

var _actions = require("../actions");

var epicMigrationActions = _interopRequireWildcard(_actions);

var _epic = require("../../../static/images/epic-migration/epic.png");

var _epic2 = _interopRequireDefault(_epic);

var _components = require("components");

var _SignInWithEpicButton = require("./SignInWithEpicButton.scss");

var _SignInWithEpicButton2 = _interopRequireDefault(_SignInWithEpicButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignInWithEpicButton = function (_React$Component) {
  (0, _inherits3.default)(SignInWithEpicButton, _React$Component);

  function SignInWithEpicButton(props) {
    (0, _classCallCheck3.default)(this, SignInWithEpicButton);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SignInWithEpicButton.__proto__ || (0, _getPrototypeOf2.default)(SignInWithEpicButton)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(SignInWithEpicButton, [{
    key: "handleClick",
    value: function handleClick(ev) {
      var _props = this.props,
          rememberWeAreRedirectingToEpicLogin = _props.rememberWeAreRedirectingToEpicLogin,
          router = _props.router,
          isRegisterLinkVariant = _props.isRegisterLinkVariant;
      var location = router.location;


      rememberWeAreRedirectingToEpicLogin(location, isRegisterLinkVariant ? "register" : "login");

      ev.preventDefault();
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          isRegisterLinkVariant = _props2.isRegisterLinkVariant,
          registerLinkStyles = _props2.registerLinkStyles;


      return isRegisterLinkVariant ? _react2.default.createElement(_components.TextButtonLibrary, {
        type: "button",
        className: registerLinkStyles,
        mode: "small",
        to: "",
        onClick: this.handleClick,
        label: "Register"
      }) : _react2.default.createElement(
        "button",
        {
          type: "button",
          className: _SignInWithEpicButton2.default.button,
          onClick: this.handleClick
        },
        _react2.default.createElement("img", { alt: "Epic Games Logo", src: _epic2.default }),
        "Sign in with Epic Games"
      );
    }
  }]);
  return SignInWithEpicButton;
}(_react2.default.Component);

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(null, {
  rememberWeAreRedirectingToEpicLogin: epicMigrationActions.rememberWeAreRedirectingToEpicLogin
})(SignInWithEpicButton));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/SignInWithEpicButton.jsx
// module id = 1255
// module chunks = 0